import { SHOW_LOADING, HIDE_LOADING } from "../actions/loadingActions";

const initialState = {
	loading: false,
};

export default function loadingReducer(state = initialState, action: { type: string }) {
	switch (action.type) {
		case SHOW_LOADING:
			return { loading: true };
		case HIDE_LOADING:
			return { loading: false };
		default:
			return state;
	}
}
